<template>
    <div
        ref="dropdown"
        class="d-button-dropdown"
    >
        <DButton
            :label="label"
            :disabled="disabled"
            :mini="mini"
            :color="color"
            icon="dots-horizontal"
            @click="toggleDropdown"
        />
        <div
            v-if="isOpen"
            class="d-dropdown"
            @click="toggleDropdown"
        >
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'DButtonDropdown',
    props: {
        label: {
            type: String,
            default: '',
            required: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        mini: {
            type: Boolean,
            required: false,
            default: false
        },
        color: {
            type: String,
            required: false,
            default: 'secondary'
        }
    },
    data () {
        return {
            isOpen: false
        }
    },
    mounted () {
        document.addEventListener('click', this.handleClickOutside)
    },
    beforeUnmount () {
        document.removeEventListener('click', this.handleClickOutside)
    },
    methods: {
        toggleDropdown () {
            this.isOpen = !this.isOpen
        },
        handleClickOutside (event) {
            if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
                this.isOpen = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.d-button-dropdown {
    position: relative;

    & .d-dropdown {
        width: 250px;
        background: #fff;
        border-radius: 5px;
        box-shadow: 0px 1px 3px rgba(0,0,0,0.24);
        position: absolute;
        z-index: 100;
        right: 0;
        margin-top: 5px;
    }
}
</style>
